var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 text-brand-text text-sm h-full overflow-y-auto",style:({
    maxHeight: `calc(
      100vh - var(--vertical-padding, 0px) - var(--modal-header-height, 0px) -
        var(--modal-footer-height, 0px)
    )`,
  }),attrs:{"data-component":"CsModalContent"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }